// 评教管理模块urls
export const pjglUrls = {

    /**
     * 评教设置urls
     */
    pjszUrls: {
        // 保存评教设置
        save: '/pjgl/pjsz/save',
        // 查询评教设置
        getPjsz: '/pjgl/pjsz/getPjsz',
        // 学生查询评教账号设置
        getPjzhsz: '/pjgl/pjzhsz/getPjzhsz'
    },
    /**
     * 评教指标urls
     */
    pjzbUrls: {
        //查询题型树
        getQuestionTypeTree: '/pjgl/pjzb/getQuestionTypeTree',
        //分页查询评教指标
        findPage: '/pjgl/pjzb/findPage',
        //保存评教指标
        save: '/pjgl/pjzb/save',
        //修改评教指标的启用类型
        updEnable: '/pjgl/pjzb/updEnable',
        //删除评教指标
        delByOpenid: '/pjgl/pjzb/delByOpenid',
    },

    /**
     * 学生教师评教urls
     */
    xsjsPjUrls: {
        // 查询所有评教批次
        selectAllPjpc: '/pjgl/xsjspj/selectAllPjpc',
        // 查询所有评教类型
        findAllByTeacher: '/pjgl/pjlx/findAllByTeacher',
        // 分页查询被评教人列表
        findPageBpjr: '/pjgl/xsjspj/findPageBpjr',
        // 查询评教模板详情
        getPjmbDetail: '/pjgl/xsjspj/getPjmbDetail',
        // 查询评教结果
        xsJsQueryPjcyr: '/pjgl/xsjspj/xsJsQueryPjcyr',
        // 保存评教结果
        savePjResult: '/pjgl/xsjspj/savePjResult',
    },

    /**
     * 评教查看urls
     */
    pjckUrls: {
        // 教师查询评教结果
        getResults: '/pjgl/pjck/getResults',
        // 管理员查询评教结果
        getAllResults: '/pjgl/pjck/getAllResults',
        // 查询每项指标平均分
        getPjzbPjfs: '/pjgl/pjck/getPjzbPjfs',
        // 分页查询意见反馈
        findPageYjfk: '/pjgl/pjck/findPageYjfk',
        findPcBpjs: "/pjgl/pjck/findPcBpjs",
        exportPjjg: "/pjgl/pjck/exportPjjg"
    },

  /**
   * 评教选项urls
   */
  pjxxUrls: {
    // 保存或修改评教选项
    save: '/pjgl/pjxx/save',
    // 启用/禁用评教选项
    updEnable: '/pjgl/pjxx/updEnable',
    // 分页查询评教选项
    findPage: '/pjgl/pjxx/findPage',
    // 查询所有评教选项信息
    findAll: '/pjgl/pjxx/findAll'
  },
  /**
   * 评教选项组urls
   */
  pjxxzUrls: {
    // 保存或修改评教选项组
    save: '/pjgl/pjxxz/save',
    // 启用/禁用评教选项组
    updEnable: '/pjgl/pjxxz/updEnable',
    // 分页查询评教选项组
    findPage: '/pjgl/pjxxz/findPage',
    // 查询全部评教选项组
    findAll: '/pjgl/pjxxz/findAll'
  },
  /**
   * 评教选项分组urls
   */
  pjxxfzUrls: {
    // 保存或修改评教选项分组
    save: '/pjgl/pjxxfz/save',
    // 删除评教选项分组
    delById: '/pjgl/pjxxfz/delById',
    // 分页查询评教选项分组
    findPage: '/pjgl/pjxxfz/findPage'
  },
  /**
   * 评教内容
   */
  pjnrUrls: {
    // 保存或修改评教内容
    save: '/pjgl/pjnr/save',
    // 启用/禁用评教内容
    updEnable: '/pjgl/pjnr/updEnable',
    // 分页查询评教内容
    findPage: '/pjgl/pjnr/findPage',
    // 查询所有评教内容信息
    findAll: '/pjgl/pjnr/findAll'
  },
  /**
   * 问卷类型
   */
  wjlxUrls: {
    // 保存或修改问卷类型
    save: '/pjgl/wjlx/save',
    // 启用/禁用问卷类型
    updEnable: '/pjgl/wjlx/updEnable',
    // 分页查询问卷类型
    findPage: '/pjgl/wjlx/findPage',
    // 查询所有问卷类型信息
    findAll: '/pjgl/wjlx/findAll'
  },
  /**
   * 评教问卷
   */
  pjwjUrls: {
    // 保存或修改评教问卷
    save: '/pjgl/pjwj/save',
    // 启用/禁用评教问卷
    updEnable: '/pjgl/pjwj/updEnable',
    // 分页查询评教问卷
    findPage: '/pjgl/pjwj/findPage',
    // 查询所有评教问卷信息
    findAll: '/pjgl/pjwj/findAll'
  },
  /**
   * 问卷内容
   */
  wjnrUrls: {
    // 保存或修改评教问卷内容
    save: '/pjgl/pjwjnr/save',
    // 删除评教问卷内容
    delById: '/pjgl/pjwjnr/delById',
    // 分页查询评教问卷内容
    findPage: '/pjgl/pjwjnr/findPage'
  },
  /**
   * 评教类型
   */
  pjlxUrls: {
    // 保存或修改评教类型
    save: '/pjgl/pjlx/save',
    // 删除评教类型
    delete: '/pjgl/pjlx/delete',
    // 启用/禁用评教类型
    updEnable: '/pjgl/pjlx/updEnable',
    // 分页查询评教类型
    findPage: '/pjgl/pjlx/findPage',
    // 查询所有评教类型信息
    findAll: '/pjgl/pjlx/findAll'
  },
  /**
   * 问卷评教类型
   */
  wjpjlxUrls: {
    // 保存或修改问卷评教类型
    save: '/pjgl/wjpjlx/save',
    // 删除问卷评教类型
    delById: '/pjgl/wjpjlx/delById',
    // 分页查询问卷评教类型
    findPage: '/pjgl/wjpjlx/findPage'
  },
  /**
   * 评教批次管理
   */
  pjpcglUrls: {
    // 保存评教批次信息
    save: '/pjgl/pjpc/save',
    // 保存评教批次及批次模板信息
    saveAll: '/pjgl/pjpc/saveAll',
    // 分页评教批次信息
    findPage: '/pjgl/pjpc/findPage',
    // 查询所有评教批次信息
    findAll: '/pjgl/pjpc/findAll',
    // 删除评教批次
    delete: '/pjgl/pjpc/delete',
    // 查看评教批次详情
    findDetail: '/pjgl/pjpc/findDetail',
    // 查询所有的评教分数设置
    findAllPjfssz: '/pjgl/pjfssz/findAllPjfssz',
    // 查询所有的评教类型
    findAllPjlx: '/pjgl/pjlx/findAll',
    // 查询所有的评教模板
    findAllPjmb: '/pjgl/pjmb/findAll'
  },
  /**
   * 评教批次模板管理
   */
  pjpcmbglUrls:{
    // 保存评教批次模板
    save: '/pjgl/pjpcmb/save',
    // 删除评教批次模板
    delPjpcmb: '/pjgl/pjpcmb/delPjpcmb',
    // 根据评教模板id查询模板名称及类型名称
    findPjmbAndLx: '/pjgl/pjpcmb/findPjmbAndLx',
    // 查询评教批次模板评教范围
    findPcmbYxxxs: '/pjgl/pjpcmb/findPcmbYxxxs',
    // 预览评教批次模板信息
    ylPjpcmb: '/pjgl/pjpcmb/ylPjpcmb',
  },
  /**
   * 被评教人
   */
  bpjrUrls: {
    // 分页查询可以添加的被评教人
    findPageKtjBpjr: '/pjgl/bpjr/findPageKtjBpjr',
    // 分页查询学生评教可以添加的被评人
    findPageXspjKtjBpjr: '/pjgl/bpjr/findPageXspjKtjBpjr',
    // 分页查询已添加的被评教人（以课程为核心）
    findPageExistBpjr: '/pjgl/bpjr/findPageExistBpjr',
    // 分页查询已添加的被评教人（以教师为核心）
    jsFindPageExistBpjr: '/pjgl/bpjr/jsFindPageExistBpjr',
    // 分页查询评教模板已添加的被评教人
    findPageExistMbBpr: '/pjgl/bpjr/findPageExistMbBpr',
    // 保存被评教人
    save: '/pjgl/bpjr/save',
    // 添加默认的评教人
    addDefaultBpr: '/pjgl/bpjr/addDefaultBpr',
    // 删除被评教人
    delete: '/pjgl/bpjr/delete',
    // 查询被评教人教授的教学班信息集合
    findBprKtjJxbs: '/pjgl/bpjr/findBprKtjJxbs',
    // 导入评教人信息
    uploadPjrExcel: '/pjgl/bpjr/uploadPjrExcel',

  },
  /**
   * 参评人
   */
  cprUrls:{
    // 分页查询可以添加的教师（评教参与人）
    findPageKtjJsCyr: '/pjgl/pjcyr/findPageKtjJsCyr',
    // 分页查询可以添加的学生（参评人）
    findPageKtjXsCyr: '/pjgl/pjcyr/findPageKtjXsCyr',
    // 分页查询已添加的评教参与人
    findPageExistCyr: '/pjgl/pjcyr/findPageExistCyr',
    // 分页查询评教模板已添加的参评人
    findPageExistMbCyr: '/pjgl/pjcyr/findPageExistMbCyr',
    // 添加评教参与人
    save: '/pjgl/pjcyr/save',
    // 删除评教参与人
    delete: '/pjgl/pjcyr/delete',

  },
  /**
   * 评教批次问卷
   */
  pjpcwjUrls: {
    // 保存或修改评教问卷内容
    save: '/pjgl/pjpcwj/save',
    // 删除评教问卷内容
    delById: '/pjgl/pjpcwj/delById',
    // 分页查询评教批次问卷
    findPage: '/pjgl/pjpcwj/findPage',
    // 复制其他评教批次
    copy: '/pjgl/pjpcwj/copy',
    // 评教参与人根据评教批次查询所有评教批次问卷
    findAllByPjcyr: '/pjgl/pjpcwj/findAllByPjcyr',
    // 管理员根据评教批次查询所有评教批次问卷
    findAll: '/pjgl/pjpcwj/findAll',
    // 评教参与人查询评教信息
    getQuestionairesByPjcyr: '/pjgl/pjpcwj/getQuestionairesByPjcyr',
    // 管理员查询评教信息
    getQuestionaires: '/pjgl/pjpcwj/getQuestionaires',
  },
  /**
   * 评教人管理
   */
  pjrglUrls: {
    // excel导入评教人信息
    uploadPjrExcel: '/pjgl/pjrgl/uploadPjrExcel',
    // 分页查询未添加的评教参与人
    findPagePjrByWjidAndbpjrid: '/pjgl/pjrgl/findPagePjrByWjidAndbpjrid',
    // 根据评教批次问卷分页查询被评教人信息
    findPage: '/pjgl/bpjr/findPage',
    // 根据评教批次问卷新增被评教人信息
    save: '/pjgl/bpjr/save',
    // 删除被评教人信息
    delById: '/pjgl/bpjr/delById',
    // 根据被评教人分页查询评教参与人
    findPagePjcyrByBpjrId: '/pjgl/bpjr/findPagePjcyrByBpjrId',
    // 给被评教人添加评教参与人
    savePjcyr: '/pjgl/bpjr/savePjcyr',
    // 删除评教参与人
    delPjcyrs: '/pjgl/bpjr/delPjcyrs',
  },
  /**
   * 学生教师评教
   */
  xsjspjUrls: {
    // 查询所有评教批次
    selectAllPjpc: '/pjgl/xsjspj/selectAllPjpc',
    // 分页查询被评教人列表
    findPageBpjr: '/pjgl/xsjspj/findPageBpjr',
    // 根据评教查询结果
    xsJsQueryPjcyr: '/pjgl/xsjspj/xsJsQueryPjcyr',
    // 保存评教结果
    savePjResult: '/pjgl/xsjspj/savePjResult',
  },
  /**
   * 未评教信息查询
   */
  wpjUrls: {},
  /**
   * 评教结果查询
   */
  pjjgcxUrls: {
    // 查询评教结果
    getPjjg: '/pjgl/pjcx/getPjjg',
    // 查询被评教人的各问卷评教结果
    getWjpjjg: '/pjgl/pjcx/getWjpjjg',
    // 查询被评教人评教问卷的各评教内容评教结果
    getWjnrpjjg: '/pjgl/pjcx/getWjnrpjjg',
    // 查询被评教人评教问卷的所有评教建议
    getBpjrPjjy: '/pjgl/pjcx/getBpjrPjjy',
    // 评教结果统计
    getPjjgtj: '/pjgl/pjcx/getPjjgtj',
    // 生成评教结果excel
    downloadPjjg: '/pjgl/pjcx/downloadPjjg'
  },
  /**
   * 评教分析统计
   */
  pjfxtjUrls: {},
  /**
   * 文件上传下载
   */
  fileUrls: {
    download: '/pjgl/files/download',
    downloadfile: '/file/files/downloadFile',
    //错误数据下载
    downloaderr: '/file/files/download',
  },
  /**
   * 教学安排模块相关url
   */
  jxapUrls: {
    // 查询所有学期
    getAllXq: '/pjgl/xqgl/getAll',
  },
  /**
   * 基础资源模块相关url
   */
  footerUrls: {
    // 查询全部院系
    getAllYxxxs: '/pjgl/zzjg/getAllYxxxs',
    // 根据条件查询院系
    getYxxxs: '/pjgl/zzjg/getYxxxs',
    // 查看部门树（院系、专业、教学班树）
    findYxZyJxbTree: '/pjgl/zzjg/findYxZyJxbTree',
    // 分页查询教师列表
    getTeachers: '/pjgl/teacher/getTeachers',
    // 分页查询行政班列表
    findPageXzb: '/pjgl/xzbsz/getXzbs'
  },
  featherUrls: {
    // 根据数据字段查询数据字典信息集合
    findBySjzd: '/pjgl/sjzd/findBySjzd'
  },
  /**
   * 评教分数设置url
   */
  scoreSetUrls: {
    //分页查询分数设置
    selectPage: '/pjgl/pjfssz/selectPage',
    //新增或编辑分数设置
    save: '/pjgl/pjfssz/save',
    //删除
    delete: '/pjgl/pjfssz/delete',
    //启用/禁用评教分数设置
    updEnable: '/pjgl/pjfssz/updEnable',
    // 根据评教分数设置id查询具体信息
    findDetailByPjfsszid: '/pjgl/pjfssz/findDetailByPjfsszid',
    findAllPjfssz: '/pjgl/pjfssz/findAllPjfssz'
  },
  /**
   * 评教模板管理设置url
   */
  apprisalTemplate: {
    // 分页查询评教模板
    findPage: '/pjgl/pjmb/findPage',
    // 保存评教模板
    save: '/pjgl/pjmb/save',
    // 启用/禁用评教模板
    updEnable: '/pjgl/pjmb/updEnable',
    // 删除
    delByOpenid: '/pjgl/pjmb/delByOpenid',
    // 查询所有评教模板
    findAll: '/pjgl/pjmb/findAll',
    // 查询评教模板下的所有评教指标
    getAllPjzbs: '/pjgl/pjmbzb/getAllPjzbs',

  },
}
